import styled from 'styled-components';
import ChartCard from '../ChartCard';

export const CustomChartCard = styled(ChartCard)`
  /* max-width: 392px; */
`;
